export default __webpack_public_path__ + "static/d7ac3cc9cf8352039a3ddba1371df4f7.png";